module.exports = __webpack_public_path__ + "img/news.184abb32.svg";